<template>
  <div>
    <h1 class="text-white mb-8 font-bold text-3xl">PARÁMETROS</h1>
    <div class="mb-6 flex justify-between items-center">
      <search-filter v-model="form.search" class="w-full max-w-md mr-4" @reset="reset">
        <label class="block text-gray-700">Role:</label>
        <select v-model="form.role" class="mt-1 w-full form-select">
          <option :value="null" />
          <option value="Admin">Admin</option>
          <option value="Administrativo">Administrativo</option>
          <option value="Cliente">Cliente</option>
          <option value="Empleado">Empleado</option>

        </select>
        <label class="mt-4 block text-gray-700">Trashed:</label>
        <select v-model="form.trashed" class="mt-1 w-full form-select">
          <option :value="null" />
          <option value="with">With Trashed</option>
          <option value="only">Only Trashed</option>
        </select>
      </search-filter>
      <inertia-link style="color: white;" v-if="$page.props.auth.user.rol =='Admin'" class="px-8 py-4 btn-indigoOrange" :href="route('forexs.create')">
        <span>NUEVO</span>
        <span class="hidden md:inline">PARÁMETRO</span>
      </inertia-link>
    </div>
    <div class="bg-white rounded-md shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap">
        <tr class="text-left font-bold" style="background-color: black; color: white;">
          <th class="px-6 pt-6 pb-4">Fecha</th>
          <th class="px-6 pt-6 pb-4">Total Operaciones</th>
          <th class="px-6 pt-6 pb-4">Ganado</th>
          <th class="px-6 pt-6 pb-4">Perdido</th>
          <th class="px-6 pt-6 pb-4">Balance Inicial</th>
          <th class="px-6 pt-6 pb-4" colspan="2">Total Balance</th>
        </tr>
        <tr v-for="parameter in forexs" :key="parameter.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
          <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center" :href="route('forexs.edit', parameter.id)" tabindex="-1">
              {{ parameter.fecha }}
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center" :href="route('forexs.edit', parameter.id)" tabindex="-1">
              {{ parameter.total_traders }}
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center" :href="route('forexs.edit', parameter.id)" tabindex="-1">
              {{ parameter.dinero_ganado }}
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center" :href="route('forexs.edit', parameter.id)" tabindex="-1">
              {{ parameter.dinero_perdido }}
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center" :href="route('forexs.edit', parameter.id)" tabindex="-1">
              {{ parameter.balance_inicial }}
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center" :href="route('forexs.edit', parameter.id)" tabindex="-1">
              {{ parameter.total_general }}
            </inertia-link>
          </td>
          <td class="border-t w-px">
            <inertia-link class="px-4 flex items-center" :href="route('forexs.edit', parameter.id)" tabindex="-1">
              <icon name="cheveron-right" class="block w-6 h-6 fill-gray-400" />
            </inertia-link>
          </td>
        </tr>
        <tr v-if="forexs.length === 0">
          <td class="border-t px-6 py-4" colspan="4">No existen Parámetros.</td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
import Icon from '@/Shared/Icon'
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import SearchFilter from '@/Shared/SearchFilter'

export default {
  metaInfo: { title: 'Parámetros' },
  components: {
    Icon,
    SearchFilter,
  },
  layout: Layout,
  props: {
    filters: Object,
    forexs: Array,
  },
  data() {
    return {
      form: {
        search: this.filters.search,
        role: this.filters.role,
        trashed: this.filters.trashed,
      },
    }
  },
  watch: {
    form: {
      deep: true,
      handler: throttle(function() {
        this.$inertia.get(this.route('forexs'), pickBy(this.form), { preserveState: true })
      }, 150),
    },
  },
  methods: {
    reset() {
      this.form = mapValues(this.form, () => null)
    },
  },
}
</script>
